/**
 * Label name limits shared by the mail-side label dialog [E] and Settings → 标签 [F]: the
 * server rejects names longer than 64 code points (repo/accounts.cpp kMaxLabelName), so the
 * client counts code points too (not UTF-16 units: an emoji is one character).
 */
import type { TooManyLabelsDetails } from '@/api/types';
import { t } from '@/i18n/zh';

export const LABEL_NAME_MAX = 64;

/** Length in code points (what the server counts). */
export const labelNameLength = (name: string): number => Array.from(name).length;

/**
 * `maxLength` for a label name input: room above the limit (counted in UTF-16 units, so
 * surrogate pairs fit) so an over-long paste is reported instead of silently cut.
 */
export const LABEL_NAME_INPUT_MAX = LABEL_NAME_MAX * 2 + 20;

/** Server cap on labels per user (409 `too_many_labels`, `details.limit`). */
export const LABEL_LIMIT = 500;

/** "标签数量已达上限（500 个）…" for a 409 `too_many_labels`, using `details.limit` when present. */
export function tooManyLabelsMessage(details: Partial<TooManyLabelsDetails>): string {
  const limit = typeof details.limit === 'number' && details.limit > 0 ? details.limit : LABEL_LIMIT;
  return t('errors.too_many_labels', { limit });
}
